import EntitlementLimit from './EntitlementLimit';

export default EntitlementLimit;
